 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"b6bc98921fd71072f25899dbca57a4cc9e705352","1":"4fe38806ff41bd407edf2c1d3c357d5262b5f653","2":"76b9195fb22ae8a3378605e6a81b6017600e8e6f","3":"9c69b403b3360fa0c3142be19de83c726d7b7070","4":"1878d2cc3cf0594fbcfdb830488c5e08a189e661","5":"styles","6":"39641c91c878fad60f8877b86e53cd50bc445d46","7":"7512be0d93cec916e6c04b9d284f7b28c88dcdb7","8":"89553fb8e42622bd97b24d134c197cd3559e37a8","9":"94726e6d","10":"b526f6a17747972fb42c32e5db01cd094261ad69","12":"0b7b90cd","13":"76d22f9e","16":"component---cache-caches-gatsby-plugin-offline-app-shell-js","17":"component---src-pages-404-js","18":"component---src-pages-about-us-js","19":"component---src-pages-calendar-js","20":"component---src-pages-church-life-js","21":"component---src-pages-contact-copy-js","22":"component---src-pages-contact-js","23":"component---src-pages-giving-js","24":"component---src-pages-hall-for-hire-js","25":"component---src-pages-index-js","26":"component---src-pages-jobs-js","27":"component---src-pages-lifegroups-js","28":"component---src-pages-login-js","29":"component---src-pages-media-audio-js","30":"component---src-pages-media-prayer-meetings-js","31":"component---src-pages-media-videos-js","32":"component---src-pages-missions-js","33":"component---src-pages-our-team-js","34":"component---src-pages-register-js","35":"component---src-pages-services-js","36":"component---src-pages-serving-js","37":"component---src-pages-testimonies-js","38":"component---src-pages-whats-on-js","39":"component---src-pages-youth-js"}[chunkId]||chunkId) + "-" + {"0":"69b6b0b2c2a989017044","1":"4baf8240e81eef700797","2":"df107f43fcc2f9199e0b","3":"b54bed0a02f05363024e","4":"d1e8c6531719fb18b75e","5":"cbe1aab8157df34022ac","6":"f09891cb9bc408895f3c","7":"b5d7ffd34c42ea48bc28","8":"3477a5575d2c89651434","9":"5ed4a4481b0c1faceaad","10":"03cee912fb1038480643","12":"d5b68bae7517ed7fa1d6","13":"9979b33da1ecef945d9a","16":"2326b49774fae963480b","17":"131198219984264c39d2","18":"7dfc96df7eb027ad2442","19":"382f7397a2bc8e4ef04d","20":"3e61de3ca795d10561ad","21":"a9155cb266beeceb03a6","22":"c003c71f9c533f5f684d","23":"b79c8d96ffac83ac8474","24":"d7939635c34f0ffa328b","25":"df0601a1eb9ca32482a8","26":"e1232c08039a39a849e6","27":"45375129c7cc650d70a1","28":"2d88e72be15e44f3d15e","29":"bd582e9a83df8ed16a2c","30":"68f8127ad9321d0a5f29","31":"9cc62f9dab29ff15989a","32":"9e0cc6b23d4fc0c4a093","33":"417fd828b44775925556","34":"bada6ca0ea97f546a086","35":"1d33bbd6f65203d95b93","36":"8741145756a763ff5d20","37":"6eb02c4067e6a454c299","38":"f0eb044261bc02dcf525","39":"bc25463bf81e0b39d2a1","42":"62baa897203c221ad025","43":"4c3d841171e41e77151a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"5":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"b6bc98921fd71072f25899dbca57a4cc9e705352","1":"4fe38806ff41bd407edf2c1d3c357d5262b5f653","2":"76b9195fb22ae8a3378605e6a81b6017600e8e6f","3":"9c69b403b3360fa0c3142be19de83c726d7b7070","4":"1878d2cc3cf0594fbcfdb830488c5e08a189e661","5":"styles","6":"39641c91c878fad60f8877b86e53cd50bc445d46","7":"7512be0d93cec916e6c04b9d284f7b28c88dcdb7","8":"89553fb8e42622bd97b24d134c197cd3559e37a8","9":"94726e6d","10":"b526f6a17747972fb42c32e5db01cd094261ad69","12":"0b7b90cd","13":"76d22f9e","16":"component---cache-caches-gatsby-plugin-offline-app-shell-js","17":"component---src-pages-404-js","18":"component---src-pages-about-us-js","19":"component---src-pages-calendar-js","20":"component---src-pages-church-life-js","21":"component---src-pages-contact-copy-js","22":"component---src-pages-contact-js","23":"component---src-pages-giving-js","24":"component---src-pages-hall-for-hire-js","25":"component---src-pages-index-js","26":"component---src-pages-jobs-js","27":"component---src-pages-lifegroups-js","28":"component---src-pages-login-js","29":"component---src-pages-media-audio-js","30":"component---src-pages-media-prayer-meetings-js","31":"component---src-pages-media-videos-js","32":"component---src-pages-missions-js","33":"component---src-pages-our-team-js","34":"component---src-pages-register-js","35":"component---src-pages-services-js","36":"component---src-pages-serving-js","37":"component---src-pages-testimonies-js","38":"component---src-pages-whats-on-js","39":"component---src-pages-youth-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"cc7026a4b6ec8ad319b3","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
